<template>
  <div>
    <div class="flex-box fl-between">
      <div>
        <div class="info-noticeimg"><img alt="image" :src="this.img"></div>
        <span class="">{{ this.type }}</span>
      </div>
      <span class="notice-time">{{ this.time }}</span>
    </div>
    <div>
      <div class="notice">
        <span class="notice-text"><span>{{ this.text }}</span></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoticeItem',
  props: ['text', 'type', 'img', 'time']
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a:hover{
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Notice/NoticeItem.vue